import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { learningAPI } from '../api/client';
import { ArrowLeft, Clock, CheckCircle } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import ReactPlayer from 'react-player';

const LessonPlayer = () => {
  const { lessonId } = useParams();
  const navigate = useNavigate();
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLesson();
  }, [lessonId]);

  const loadLesson = async () => {
    try {
      const response = await learningAPI.getLesson(lessonId);
      setLesson(response.data);
    } catch (error) {
      console.error('Ders yüklenemedi:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!lesson) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600 mb-4">Ders bulunamadı</p>
        <button
          onClick={() => navigate(-1)}
          className="text-blue-600 hover:text-blue-700"
        >
          Geri Dön
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
      >
        <ArrowLeft size={20} />
        Kursa Dön
      </button>

      {/* Lesson Header */}
      <div className="bg-white rounded-lg shadow-lg p-8 mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{lesson.title}</h1>
        <p className="text-lg text-gray-600 mb-4">{lesson.description}</p>
        
        {lesson.duration && (
          <div className="flex items-center gap-2 text-gray-600">
            <Clock size={20} />
            <span>{lesson.duration} dakika</span>
          </div>
        )}
      </div>

      {/* Video Player (if video exists) */}
      {lesson.videoUrl && (
        <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-6">
          <div className="relative aspect-video bg-black">
            <ReactPlayer
              url={lesson.videoUrl}
              controls
              width="100%"
              height="100%"
              playing={false}
              config={{
                youtube: {
                  playerVars: { showinfo: 1 }
                },
                vimeo: {
                  playerOptions: { byline: false }
                }
              }}
            />
          </div>
        </div>
      )}

      {/* Lesson Content */}
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="prose prose-lg max-w-none">
          <ReactMarkdown>{lesson.content}</ReactMarkdown>
        </div>
      </div>

      {/* Complete Button */}
      <div className="mt-8 flex justify-between items-center">
        <button
          onClick={() => navigate(-1)}
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
        >
          Kursa Dön
        </button>
        <button className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700">
          <CheckCircle size={20} />
          Dersi Tamamla
        </button>
      </div>
    </div>
  );
};

export default LessonPlayer;
